import React from 'react';
import { Button, Form, Input, Typography } from 'antd';
import AuthLayout from '../../../Layout/AuthLayout';
import { getRoutes } from '../../../constants/Routes';
import { useDispatch } from 'react-redux';
import { setAuth } from '../../../redux/slices/authSlice';
import { loginUser } from '../../../redux/actions/auth';
import { setNotificationSound } from '../../../redux/slices/preferenceSlice';

const Login = () => {
  const dispatch = useDispatch();

  const handleLogin = async (values) => {
    const res = await loginUser(values);
    if (res?.ack) {
      const setting = JSON.parse(res?.user?.settings)
      dispatch(setAuth(res.token));
      dispatch(setNotificationSound(setting?.notification))
      window.location.href = '/';
    }
  };

  return (
    <AuthLayout title=" Welcome Back!" subtitle="Please log in to your account">
      <div className="Login">
        <div className="Login__Container">
          <Form name="login" layout="vertical" className="Login__Form" onFinish={handleLogin}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Please enter your email!' },
                { type: 'email', message: 'Please enter a valid email!' },
              ]}
            >
              <Input size="large" placeholder="Enter your email" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please enter your password!' }]}
            >
              <Input.Password size="large" placeholder="Enter your password" />
            </Form.Item>

            <div className="Login__Options">
              <a href={getRoutes().forgot_password.route()} className="Login__Forgot">
                Forgot Password?
              </a>
            </div>

            <Form.Item>
              <Button type="primary" htmlType="submit" size="large" block className="Login__Button">
                Login
              </Button>
            </Form.Item>
          </Form>

          <Typography.Paragraph className="Login__Register">
            Don't have an account?{' '}
            <a href="/auth/register" className="Login__RegisterLink">
              Register here
            </a>
          </Typography.Paragraph>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
